import { Component } from 'preact'
import PanelHeader from './PanelHeader'
import PanelBody from './PanelBody'

class Panel extends Component {
  constructor (props) {
    super()
    this.state = {
      isOpen: true
    }
  }

  togglePanel () {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render ({ children, class: customClass, collapsible, title, titleClass: customTitleClass, bodyClass: customBodyClass }, { isOpen }) {
    return (
      <div className={`${customClass || ''} ${!isOpen || !children.length ? 'panel-collapsed' : ''}`}>
        <div class='panel'>
          { title
            ? <PanelHeader
              collapsible={collapsible}
              isOpen={isOpen}
              togglePanel={() => this.togglePanel()}
              title={title}
              customClass={customTitleClass}
            />
            : null }
          { children.length ? (
            <PanelBody
              collapsible={collapsible}
              isOpen={isOpen}
              customClass={customBodyClass}
            >
              {children}
            </PanelBody>
          ) : null }
        </div>
      </div>
    )
  }
}

export default Panel
